export const ADD_LOTUNIT_SUCCESS = 'ADD_LOTUNIT_SUCCESS';
export const FETCH_LOTUNIT = 'FETCH_LOTUNIT';
export const DELETE_LOTUNIT_SUCCESS = 'DELETE_LOTUNIT_SUCCESS';
export const EDIT_LOTUNIT_SUCCESS = 'EDIT_LOTUNIT_SUCCESS';
export const SET_SEARCH_LOTUNITS = 'SET_SEARCH_LOTUNITS';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const SET_SEARCH_LOTS = ' SET_SEARCH_LOTS';
